import { Status, STATUS_STYLE } from "./types";

export default function StatusBadge({ status }: { status: Status }) {
  return (
    <span data-testid="lead-status-badge" className={`inline-block rounded-sm border px-2 py-0.5 font-mono text-[11px] uppercase ${STATUS_STYLE[status]}`}>
      {status}
    </span>
  );
}
